import { useEffect, useState } from "react";
import {
  useAlertStore,
  useGeneralStore,
  usePopupStore,
  useThemeStore,
} from "../../../stores";
import { Cheque, ChequeSelectorItem, Customer, Factor } from "../../../types";
import { UpdateSpentFactorProps } from "./types";
import { Column, Row } from "../../containers";
import { PopupBack, PopupClose } from "../../../popup";
import { Heading } from "../../typography";
import { ChequeSelector } from "../../cheque";
import { ChequeApi, FactorApi } from "../../../api";
import { SelectorInput, TextInput } from "../../inputs";
import { Button } from "../../buttons";
import { JustifyContent } from "../../containers/types";

const UpdateSpentFactor = <T extends {} & { factor: Factor }>(
  props: UpdateSpentFactorProps<T>
) => {
  const { factor, back, updateCb } = props;

  const theme = useThemeStore((s) => s.theme);
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);
  const customers = useGeneralStore((s) => s.customers);
  const getCustomerById = useGeneralStore((s) => s.getCustomerById);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);
  const pushAlert = useAlertStore((s) => s.pushAlert);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxHeight: "80%",
        overflowY: "auto",
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const [cheques, setCheques] = useState<Array<Cheque>>([]);

  const [customer, setCustomer] = useState<Customer | null>(null);
  const [desc, setDesc] = useState<string>("");
  const [delCheques, setDelCheques] = useState<Array<ChequeSelectorItem>>([]);
  const [newCheques, setNewCheques] = useState<Array<ChequeSelectorItem>>([]);

  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setCustomer(getCustomerById(factor.customer.$oid));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [factor.customer.$oid]);

  useEffect(() => {
    FactorApi.getCheques(factor._id)
      .then((res) => {
        setCheques(res);
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const onSearchCheque = (searchValue: string): Promise<Array<Cheque>> => {
    return ChequeApi.search({
      number: searchValue.toLowerCase(),
      account_no: "",
      bank: null,
      confirmedWith: "",
      fromDate: 0,
      name: "",
      price: 0,
      shenase: "",
      status: { status: "delivered", fa: "" },
      toDate: 0,
    });
  };

  const onSave = (): void => {
    setLoading(true);
    FactorApi.updateSpentFactor(
      factor._id.$oid,
      customer,
      desc,
      delCheques,
      newCheques
    )
      .then((res) => {
        if (updateCb) updateCb();
        setPopupBody(
          back ? <back.component {...back.props} factor={res} /> : null
        );
        pushAlert("عملیات موفقیت آمیز");
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Column style={{ padding: "1rem", position: "relative" }} gap={20}>
      <PopupClose />

      {back ? (
        <PopupBack Component={back.component} props={back.props} />
      ) : (
        <></>
      )}

      <Heading color={theme.textOnOverlay} size={18}>
        ویرایش فاکتور خرج شده
      </Heading>

      <Row style={{ width: "100%" }} gap={20} className="factor-activity-row">
        <SelectorInput<Customer>
          items={customers}
          uniqueKey={"fullname"}
          selected={customer}
          setSelected={setCustomer}
          stringField={"fullname"}
          renderStrings={["fullname", "phone"]}
          compareFn={(c, v) =>
            c.fullname.toLowerCase().includes(v.toLowerCase()) ||
            c.phone.includes(v)
          }
          label="نام مشتری"
        />

        <TextInput
          label="بابت"
          value={desc}
          setValue={setDesc}
          inputProps={{ placeholder: factor.description }}
        />
      </Row>

      <ChequeSelector
        items={cheques}
        label="حذف چک"
        selectedItems={delCheques}
        setSelectedItems={setDelCheques}
      />

      <ChequeSelector
        items={onSearchCheque}
        label="افزودن چک"
        selectedItems={newCheques}
        setSelectedItems={setNewCheques}
      />

      <Row style={{ width: "100%" }} justifyContent={JustifyContent.End}>
        <Button
          background={theme.primary}
          color={theme.textOnprimary}
          onClick={onSave}
          loading={loading}
        >
          ذخیره
        </Button>
      </Row>
    </Column>
  );
};

export default UpdateSpentFactor;
